// App.js
import React from "react";
import CustomizationPanel from "./components/CustomizationPanel";

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-100 flex flex-col font-sans text-gray-800">
      <header className="sticky top-0 z-10 bg-white shadow-md py-4 px-6 text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-indigo-700">
          VB - The Virtual Atelier
        </h1>
      </header>

      <main className="flex flex-col md:flex-row max-w-7xl mx-auto mt-6 mb-12 gap-6 px-4 w-full">
        {/* Customization Panel (left side) */}
        <CustomizationPanel />
      </main>
    </div>
  );
}

export default App;
